export function setFavorites (state, favorites) {
  state.favorites = favorites
}
